import { Empty } from "antd";
import useIntl from "react-intl/lib/src/components/useIntl";
import { StyledCollapse } from "@lib/components/StyledComponents";
import ConfigComponent from "./ConfigComponent";
import { useBillingConfigQueries } from "@lib/apiQueries";
import { AppLoader, AppsContainer } from "@lib/components/AppComponents";

const BillingConfigs = () => {
  const { messages } = useIntl();

  const { billingConfigsQuery, updateBillingConfigMutation } =
    useBillingConfigQueries({
      messages,
      params: {
        sort: "createdAt,DESC",
      },
    });
  const apiData = billingConfigsQuery?.data?.data?.data;

  if (billingConfigsQuery.isLoading) return <AppLoader />;

  return (
    <AppsContainer
      fullView
      cardBg
      title={messages["sidebar.billingConfigs"] as string}
      // cardStyle={{
      //   padding: 20,
      // }}
    >
      <>
        {apiData.length === 0 ? (
          <Empty />
        ) : (
          <StyledCollapse
            defaultActiveKey={apiData[0]?.id as string}
            items={apiData.map((d) => ({
              key: d.id,
              label:
                (messages["enums.billing_configs"][d.name] as string) || d.name,
              children: (
                <ConfigComponent
                  config={d}
                  query={billingConfigsQuery}
                  updateQuery={updateBillingConfigMutation}
                />
              ),
            }))}
          />
        )}
      </>
    </AppsContainer>
  );
};

export default BillingConfigs;
